import { render, staticRenderFns } from "./BoardClassForm.vue?vue&type=template&id=60d96d76&"
import script from "./BoardClassForm.vue?vue&type=script&lang=js&"
export * from "./BoardClassForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports